import LogRocket from 'logrocket';
import { FBModule } from '@/helpers/firebaseServices';
import store from '@/store';

export default {
  install: () => {
    // Subscribe to user Auth change (login/logout)
    FBModule.auth().onAuthStateChanged((user) => {
      // User is not signed-in
      if (!user) {
        store.dispatch('user/auth/resetState');
        if (store.state.user.auth.isInitialLoading) store.dispatch('user/auth/updateIsInitialLoading', false);
        return;
      }

      // User is signed in
      LogRocket.identify(user.uid, {
        name: user.displayName,
        email: user.email,
      });
      store.dispatch('user/auth/updateAuthData', user).then(() => {
        if (store.state.user.auth.isInitialLoading) store.dispatch('user/auth/updateIsInitialLoading', false);
      });
    });
  },
};
